import { CmpsUser } from '../../kit';
import { CoachingTrendData } from '../card--my-coaching-card/models/coaching-trend-data.model';
import { HeaderRowData } from '../card--my-coaching-card/models/header-row-data.model';

import { PerformanceMetricData } from './models/performance-metric-data.model';
import { UserPerformanceData } from './models/user-performance-data.model';

export interface PerformanceCardState {
    pending: {
        reload?: boolean;
        hasData?: boolean;
        trendDataByKey?: Record<string, boolean>;
    };

    headerData?: HeaderRowData;
    trendCharts?: Record<string, CoachingTrendData>;
    metricPerformanceData?: PerformanceMetricData[];
    users: CmpsUser[];
    userData?: Record<string, UserPerformanceData>;
}

export const defaultState = (): PerformanceCardState => ({
    pending: {},
    users: [],
    trendCharts: {},
});
